import { ReactElement } from 'react';
import { Navigate, Route, Routes as Switch } from 'react-router-dom';

import { featureConfig } from 'modules/common/featureConfig';
import {
  DashboardRoutesConfig,
  getDashboardRoutes,
} from 'modules/dashboard/Routes';
import { getDeFiRoutes } from 'modules/defi/Routes';
import {
  DelegateStakingRoutesConfig,
  getDelegateStakingRoutes,
} from 'modules/delegateStaking/Routes';
import { getDeprecatedLiquidStakingRoutes } from 'modules/deprecatedLiquidStaking/Routes';
import { getDevRoutes } from 'modules/dev';
import { getLiquidStakingRoutes } from 'modules/liquidStaking/Routes';
import { getOwnerPanelRoutes } from 'modules/ownerPanel/Routes';
import { getPoolRoutes } from 'modules/pool/Routes';

import { RootRoute } from './RootRoute';

export function Routes(): ReactElement {
  return (
    <Switch>
      <Route element={<RootRoute />} path="/">
        {featureConfig.isDevUiEnabled && getDevRoutes()}

        {featureConfig.isDashboardEnabled && getDashboardRoutes()}

        {getDelegateStakingRoutes()}

        {getPoolRoutes()}

        {featureConfig.isDeFiEnabled && getDeFiRoutes()}

        {getOwnerPanelRoutes()}

        {featureConfig.isLiquidStakingEnabled && getLiquidStakingRoutes()}

        {featureConfig.isLiquidStakingEnabled &&
          getDeprecatedLiquidStakingRoutes()}

        <Route
          element={
            <Navigate
              to={
                featureConfig.isDashboardEnabled
                  ? DashboardRoutesConfig.dashboard.generatePath()
                  : DelegateStakingRoutesConfig.staking.generatePath()
              }
            />
          }
          path="*"
        />
      </Route>
    </Switch>
  );
}
